import { render, staticRenderFns } from "./lineBusiness.vue?vue&type=template&id=4e2745ac"
import script from "./lineBusiness.vue?vue&type=script&lang=js"
export * from "./lineBusiness.vue?vue&type=script&lang=js"
import style0 from "./lineBusiness.vue?vue&type=style&index=0&id=4e2745ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports